import { t } from '@lingui/macro'
import React from 'react'
import { AspenPermissions } from '../utils'

import { OrganizationMetadataCreateDTO, OrganizationMetadataDTO, useOrganizationMetadatas } from '@om1/aspen-api'
import { useUserPermissions } from '@om1/platform-authentication'
import { Column, GenericDataPage } from './GenericDataPage'

const orgMetadataColumns: Column<OrganizationMetadataDTO>[] = [
    { key: 'snowflakeDatabase', type: 'text', editable: true, required: true },
    { key: 'snowflakeRole', type: 'text', editable: true, required: true }
]

const SnowflakePage: React.FC = () => {
    const { permissions } = useUserPermissions()
    const { response } = useOrganizationMetadatas()

    const canCreateOrgMetadata = permissions?.includes(AspenPermissions.ADMIN) && response?.meta.totalItems === 0

    return (
        <GenericDataPage<OrganizationMetadataDTO, 'id', OrganizationMetadataCreateDTO>
            useData={useOrganizationMetadatas}
            useDataArgs={[]}
            canCreate={canCreateOrgMetadata}
            columns={orgMetadataColumns as Column<OrganizationMetadataDTO>[]}
            title={t`Snowflake Connection`}
            orientation='vertical'
        />
    )
}

export default SnowflakePage
